/**
 * International SEO Utilities
 * Single-language site: English only.
 * Hreflang: en + x-default pointing to canonical URL.
 * No fake geo.region duplicates — one per page is enough.
 */

export const getInternationalMetaTags = (pathname = '/') => {
  const baseUrl = 'https://safeedges.in';
  const currentUrl = `${baseUrl}${pathname === '/' ? '' : pathname}`;

  return {
    hreflangTags: [
      { lang: 'en', href: currentUrl },
      { lang: 'x-default', href: currentUrl },
    ],
    geoMetaTags: [],
  };
};

export const getInternationalStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Safe Edges",
  "alternateName": "SafeEdges",
  "description": "Smart contract audit firm trusted by 200+ Web3 projects. $4B+ in digital assets secured. Official Fuel Chain security partner.",
  "url": "https://safeedges.in",
  "logo": "https://safeedges.in/logo.png",
  "foundingDate": "2023",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "info@safeedges.in",
    "availableLanguage": "English"
  },
  "sameAs": [
    "https://twitter.com/SafeEdges",
    "https://www.linkedin.com/company/safe-edges",
    "https://safe-edges.medium.com/"
  ]
});

const seoInternational = {
  getInternationalMetaTags,
  getInternationalStructuredData,
};

export default seoInternational;
